/**
 * Chart palette — MUST mirror the design tokens in index.css.
 * Recharts can't read CSS variables directly in stroke props, so we
 * duplicate the HSL values here. If any of these change in index.css,
 * update them here too.
 *
 * Source tokens (index.css):
 *   --color-navy-primary     → CHART_COLORS.gross / CHART_COLORS.lf
 *   --color-bronze           → CHART_COLORS.net / CHART_COLORS.sf
 *   --color-linen-soft       → CHART_COLORS.grid
 *   --color-muted-foreground → CHART_COLORS.axis
 *
 * lf/sf are the Crew Utilization monthly-footage series. They reuse the house
 * navy/bronze pair (LF gutter = navy, SF insulation = bronze) so the chart
 * reads in the same palette as Financials.
 */
export const CHART_COLORS = {
  gross: 'hsl(215 39% 30%)',  // --color-navy-primary
  net:   'hsl(36 36% 39%)',   // --color-bronze
  grid:  'hsl(35 25% 80%)',   // --color-linen-soft
  axis:  'hsl(215 25% 40%)',  // --color-muted-foreground
  lf:    'hsl(215 39% 30%)',  // --color-navy-primary (LF / gutter, linear feet)
  sf:    'hsl(36 36% 39%)',   // --color-bronze       (SF / insulation, sq feet)
} as const;
